export const colors = {
  // -------- new branding
  deepTeal: '#003333',
  robinsEggBlue: '#00B8D9',
  mossGreen: '#9DD29C',
  turbo: '#F1E900',
  // text colors
  rock: '#677F83',
  beachWind: '#DCE1E2',
  // neutral palette
  neutral100: '#FAFBFC',
  neutral200: '#F1F4F5',
  neutral300: '#E7ECEE',
  neutral400: '#DDE5E7',
  neutral500: '#CFDADD',
  neutral600: '#B4C2C6',
  neutral700: '#707D81',
  neutral800: '#334145',
  neutral900: '#0A1113',
  // success palette
  success100: '#E1F6E4',
  success500: '#49CA5A',
  success800: '#378040',
  // danger palette
  danger100: '#FFEFEF',
  danger500: '#E23A59',
  danger800: '#AB003E',
  // warning palette
  warning100: '#FFF8E4',
  warning500: '#FFC32B',
  warning800: '#C15D00',
  // info palette
  info100: '#E1F7FE',
  info500: '#33A6FA',
  info800: '#005A9B',
  // --------
  // grey to increase contrast on some screens
  alicebluegrey: '#f5f7f9',
  // --------
  primary: '#2ec4b6',
  primaryHover: '#228f85',
  primaryDisabled: 'rgba(46, 196, 182, 0.2)',
  primaryOpacity: '#e1f1f0',
  secondary: '#ff6a56',
  secondaryHover: '#e6513d',
  secondaryDisabled: 'rgba(255, 106, 86, 0.2)',
  accentBlue: '#0080ff',
  accentPurple: '#8a40f6',
  accentGreen: '#67EF84',
  accentOrange: '#F18303',
  white: '#ffffff',
  pearl: '#fafafa',
  riverstone: '#f2f3f7',
  aliceblue: '#f8f9fb',
  athensgray: '#edecee',
  cloud: '#f0f0f0',
  smoke: '#dddddd',
  gray: '#808080',
  ash: '#666666',
  charcoal: '#4c4c4c',
  palegreen: '#ecf3f3',
  success: '#39cb7b',
  error: '#f95541',
  warning: '#f9c107',
  darkgray: '#292829',
  midnightExpress: '#16223F',
  darkCerulean: '#0A4877',
  darkblue: '#093B61',
  strokeblue: '#85C0CD',
  lightblue: '#EFFFFF',
  black: '#000',
  northrend: '#B2F0FF',
  primaryBlue: '#C9E9E6',
  edgewater: '#C6E0DD',
  gunPowder: '#4c4d5b',
  whiteIce: '#ecf8f6',
  darkSilver: '#707070',
  rowRed: '#FFF6F6',
  rowOrange: '#FFF1E1',
  eclipse: '#373737',
  // These colors are still being used on other platforms (e.g. MW, UD). Please avoid using these names and instead use the colors naming outlined in the style guide.
  fennel: '#E1F6E4', // - success100
  greatGreen: '#378040', // - success800
  geyser: '#CFDADD', // - neutral500
  carnelian: '#AB003E', // -danger800
} as const;

export type ColorType = {};
